import {useApi} from "@contexts/hooks/api/useApi.ts";
import {_RecursosEndpoints} from "@localization/siteMap/endpoints/_RecursosEndpoints.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";

export function useMovimentacaoRecurso() {
    const {Get} = useApi()

    const getMovimentacaoRecursoByRecursoId = async (recursoId: number, pagination: IPagination) => {
        return await Get(_RecursosEndpoints.GetRecursosMovimentacoes({recursoId: [recursoId]}, pagination)).then(x => x.items)
    }

    const getMovimentacaoRecursoById = async (id: number) => {
        return await Get(_RecursosEndpoints.GetRecursosMovimentacoes({id: [id]}, {
            page: 1,
            pageSize: 1
        })).then(x => x.items[0])
    }

    return {
        getMovimentacaoRecursoByRecursoId: getMovimentacaoRecursoByRecursoId,
        getMovimentacaoRecursoById: getMovimentacaoRecursoById
    }
}